module.exports = __webpack_public_path__ + "img/dp-sy-lmAdmin.6835d216.png";